export type ImportTiendaNubePayload = {
    dateFrom: string;
    dateTo: string;
    status: string;
    carriers: Array<string>;
};

export type GetTiendaNubeCustomCarriersPayload = {
    idUsuario: string;
    dateTo: string;
    dateFrom: string;
    status: string;
};

export type GetDispositivosPayload = {
    idUsuario: string;
};
